import Flickity from './vendor/flickity';

const initCarouselBlocks = () => {
	const carousels = document.querySelectorAll('.block-featured-image__slides');

	carousels.forEach((carousel) => {
		if (carousel.dataset.carouselInitialized) return;

		const blockInner = carousel.closest('.block-featured-image__inner');
		const counterEl = blockInner.querySelector('.block-featured-image__counter');

		const slideCount = carousel.children.length;
		const showControls = slideCount > 1;
		
		// Add data attribute to the block for styling
		const blockElement = carousel.closest('.block-featured-image');
		if (blockElement) {
			blockElement.setAttribute('data-slide-count', slideCount);
			blockElement.setAttribute('data-show-controls', showControls);
		}

		const flickityInstance = new Flickity(carousel, {
			cellAlign: 'center',
			freeScroll: false,
			wrapAround: false,
			contain: true,
			pageDots: false,
			prevNextButtons: showControls,
			groupCells: true,
			draggable: showControls,
			selectedAttraction: 0.02,
			friction: 0.3,
		});

        // Replace default nav button SVGs with custom arrow image
        const updateNavArrows = () => {
			// Only update arrows if we're showing controls
			if (!showControls) return;
			
            const prevBtn = carousel.querySelector('.flickity-prev-next-button.previous');
            const nextBtn = carousel.querySelector('.flickity-prev-next-button.next');
        
            const svgUrl = `${window.location.origin}/wp-content/themes/syracusenews/custom-blocks/featured-image/assets/icon-right-caret.svg`;
        
            fetch(svgUrl)
                .then((res) => res.text())
                .then((svgMarkup) => {
                    if (prevBtn) {
                        prevBtn.innerHTML = svgMarkup;
                        const svg = prevBtn.querySelector('svg');
                        svg.classList.add('block-featured-image__nav-icon');
                        svg.style.transform = 'rotate(180deg)';
                    }
                    if (nextBtn) {
                        nextBtn.innerHTML = svgMarkup;
                        const svg = nextBtn.querySelector('svg');
                        svg.classList.add('block-featured-image__nav-icon');
                    }
                })
                .catch((err) => {
                    console.error('Failed to load SVG:', err);
                });
        };
		updateNavArrows();

        // Counter logic
		const updateCounter = () => {
			if (!counterEl) return;

			// Hide counter if only one slide
			if (!showControls) {
				counterEl.style.display = 'none';
				return;
			}

			// Don't set display: block, let CSS handle it
			const slideNum = flickityInstance.selectedIndex + 1;
			const totalSlides = flickityInstance.slides.length;

			// Update text span if it exists, otherwise update whole counter
			const textSpan = counterEl.querySelector('.block-featured-image__counter-text');
			if (textSpan) {
				textSpan.textContent = `${slideNum} / ${totalSlides}`;
			} else {
				counterEl.textContent = `${slideNum} / ${totalSlides}`;
			}
		};

		const setCaptionContainerHeight = () => {
            const captionsContainer = carousel.closest('.block-featured-image__inner').querySelector('.block-featured-image__captions');
            if (!captionsContainer) return;
            
            const captions = captionsContainer.querySelectorAll('.block-featured-image__caption');
            let maxHeight = 0;
            
            // Temporarily show all captions to measure their heights
            captions.forEach(caption => {
                caption.style.display = 'block';
                caption.style.opacity = '0';
                caption.style.position = 'absolute';
                caption.style.visibility = 'hidden';
                maxHeight = Math.max(maxHeight, caption.offsetHeight);
            });
            
            // Set fixed height on container
            captionsContainer.style.height = maxHeight + 'px';
            
            // Reset captions to normal state
            captions.forEach(caption => {
                caption.style.position = '';
                caption.style.visibility = '';
                caption.style.display = 'none';
                caption.style.opacity = '0';
            });
        };

		const updateCaptions = () => {
            const captionsContainer = carousel.closest('.block-featured-image__inner').querySelector('.block-featured-image__captions');
            if (!captionsContainer) return;

            const captions = captionsContainer.querySelectorAll('.block-featured-image__caption');
            const currentIndex = flickityInstance.selectedIndex;

            // Hide all captions first
            captions.forEach(caption => {
                caption.style.opacity = '0';
                caption.style.display = 'none';
            });

            // Find the caption that matches the current slide number
            const currentCaption = captionsContainer.querySelector(`[data-slide-number="${currentIndex}"]`);
            if (currentCaption) {
                currentCaption.style.display = 'block';
                currentCaption.style.opacity = '0';

                setTimeout(() => {
                    currentCaption.style.opacity = '1';
                }, 50);
            }
        };

		const updateViewportHeight = () => {
			const viewport = carousel.querySelector('.flickity-viewport');
			if (!viewport) return;

			const currentSlide = flickityInstance.selectedElement;
			if (!currentSlide) return;

			const img = currentSlide.querySelector('img');
			if (!img) return;

			// Function to set height based on current image
			const setHeight = () => {
				if (img.complete && img.naturalHeight > 0) {
					viewport.style.height = img.offsetHeight + 'px';
				}
			};

			// If image is already loaded, set height immediately
			if (img.complete) {
				setHeight();
			} else {
				// Wait for image to load
				img.addEventListener('load', setHeight, { once: true });
			}
		};

		const moveArrowsToCounter = () => {
			if (!showControls || !counterEl) return;

			const prevBtn = carousel.querySelector('.flickity-prev-next-button.previous');
			const nextBtn = carousel.querySelector('.flickity-prev-next-button.next');

			if (!prevBtn || !nextBtn) return;

			// Wrap the counter text in a span to control order
			const counterText = counterEl.textContent;
			counterEl.textContent = '';

			const textSpan = document.createElement('span');
			textSpan.className = 'block-featured-image__counter-text';
			textSpan.textContent = counterText;

			// Insert in correct order: prev button, text, next button
			counterEl.appendChild(prevBtn);
			counterEl.appendChild(textSpan);
			counterEl.appendChild(nextBtn);
		};


		// Ensure all update functions are run on init and change
		setTimeout(() => {
			setCaptionContainerHeight();
			updateCounter();
			updateCaptions();
			updateViewportHeight();
			moveArrowsToCounter();
		}, 0);

		flickityInstance.on('ready', () => {
			setCaptionContainerHeight();
			updateCounter();
			updateCaptions();
			updateViewportHeight();
			moveArrowsToCounter();
		});

		flickityInstance.on('change', () => {
			updateCounter();
			updateCaptions();
			updateViewportHeight();
		});

		// Handle window resize to recalculate viewport height
		window.addEventListener('resize', updateViewportHeight);

		carousel.dataset.carouselInitialized = true;
	});
};

// DOM ready
document.addEventListener('DOMContentLoaded', initCarouselBlocks);

// Gutenberg block preview support
if (window.acf) {
	window.acf.addAction('render_block_preview/type=block-featured-image', initCarouselBlocks);
}

// Additional editor support - check for block editor context
if (typeof wp !== 'undefined' && wp.blocks) {
	// Initialize when blocks are loaded in editor
	wp.domReady(initCarouselBlocks);
	
	// Also try with a slight delay for editor context
	setTimeout(initCarouselBlocks, 100);
}
